import isNil from 'lodash/isNil';
import React from 'react';

import LessonMeta from '../../lesson-meta';
import Link from '../../link/link';
import Text from '../../text/text';

import './prep-lessons__item-footer.scss';

interface OwnProps {
    buttonTextId?: string;
    disabled?: boolean;
    id: number;
    isCompactView: boolean;
    problemsCount?: number;
    shouldShowButton?: boolean;
    shouldShowId?: boolean;
}

interface Props extends OwnProps {}

export const PrepLessonsItemFooter = (props: Props) => {
    const { buttonTextId, disabled, id, isCompactView, problemsCount, shouldShowButton, shouldShowId } = props;
    const shouldShowProblemsCount = !isNil(problemsCount) && problemsCount >= 0;

    const textProps = {
        size: Text.SIZE.M,
        weight: Text.WEIGHT.M,
    };

    return (
        <div className="prep-lessons__item-footer">
            {shouldShowButton && (
                <Link disabled={disabled} mix="prep-lessons__item-control" theme={Link.THEME.PRIMARY}>
                    <Text id={buttonTextId} weight={Text.WEIGHT.M} />
                </Link>
            )}
            {shouldShowId && <div className="prep-lessons__item-id-label">{id}</div>}
            {shouldShowProblemsCount && (
                <LessonMeta.CardsCount
                    cardsCount={problemsCount!}
                    mix="prep-lessons__item-problem-count"
                    showIcon={isCompactView}
                >
                    {isCompactView ? (
                        <Text {...textProps}>{problemsCount}</Text>
                    ) : (
                        <Text {...textProps} id="cardsCount" values={{ cardsCount: problemsCount }} />
                    )}
                </LessonMeta.CardsCount>
            )}
        </div>
    );
};

const component = React.memo(PrepLessonsItemFooter);
component.displayName = 'PrepLessonsItemFooter';

export default component;
